module.exports = __webpack_public_path__ + "28797a0dcfef8c510465d13ceeae6232.png";